export const CONTRACT_NAMES = [
  'dao-proposal-multiple',
  // Neutron's modified contracts
  'cwd-proposal-multiple',
]

export const PRE_PROPOSE_CONTRACT_NAMES = ['dao-pre-propose-multiple']
